module.exports = {"scale":"treeLevels","orient":"top","title":"Ontology Depth (c_hlevel)"}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/axes/tree/top.json
// module id = 88ol
// module chunks = 0